import React, { useState, useEffect } from "react";
import classes from "./CashReciept.module.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { BASE_URL } from '../../../../Components/Styles/API/API';
import Swal from "sweetalert2";
import crop from "../../../../Assets/repoort.png";
import verified from "../../../../Assets/verified.svg";
import Select from "react-select";
import CurrencyInput from 'react-currency-input-field';
import { Modal, Row, Col } from 'react-bootstrap';

function CashReciept({ isOpen, onClose,fetchExpenses }) {
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
  ]);
  const [loading, setLoading] = useState(true);
  const [minDate, setMinDate] = useState("");
 const [debit1, setDebit1] = useState([]);
 const [payer,setPayer] = useState("");
  const [maxDate, setMaxDate] = useState("");
    const [debit2, setDebit2] = useState([]);
  const [reference, setReference] = useState("");
  const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [description, setDescription] = useState("");
  const [debitAccount, setDebitAccount] = useState("");
  const [outstandingAmount, setOutstandingAmount] = useState("");
  const [selectedLoanAccount, setSelectedLoanAccount] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [debit3, setDebit3] = useState([]);
  const [debit4, setDebit4] = useState([]);
  const [totalAmount, setTotalAmount] = useState("");
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [loanOptions, setLoanOptions] = useState([]);
const [loanLoading, setLoanLoading] = useState(false);
  const [accountName, setAccountName] = useState("");
  const [accountNameId, setAccountNameId] = useState("");
  const [accountCode, setAccountCode] = useState("");

  const [receiptTypesLoading, setReceiptTypesLoading] = useState(false);
const [teller,setTeller] = useState("");
const [cus, setCus] = useState([]);
  const [selectedBanks, setSelectedBanks] = useState(null)
  const [outstanding, setOutstanding] = useState("");
  const [expenseOptions, setExpenseOptions] = useState([]);
   const [selectedCustomer, setSelectedCustomer] = useState('')
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [loanAccountOptions, setLoanAccountOptions] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
   const [incomeLoading, setIncomeLoading] = useState(false);
  const [receiptType, setReceiptType] = useState("general-income");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [loanAccountSelected, setLoanAccountSelected] = useState("");
  const [currMonth, setCurrMonth] = useState('');
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  


  const handlePrinter = () => {
    const receiptData = {
      reference,
      transactionDate,
      description,
      selectedCurrency,
      selectedPaymentMode,
      debitAccount,
      totalAmount,
      rows,
    };

    navigate("/preview", {
      state: { invoice: receiptData }, // 👈 send the full receipt info
    });
  };
  const handleCustomerChange = (selectedOption) => {
        setSelectedCustomer(selectedOption.value);
        setOutstanding(selectedOption.balance);
      };
   const readData = async () => {
        try {
          const value = await localStorage.getItem('userToken');
          const value1 = await localStorage.getItem('tobi');
           const current = await localStorage.getItem('currentMonth');
    
    
          if (value !== null && value.trim() !== '') {
            setBearer(value);
          }
           if (current !== null) {
        console.log(current)
        const date = new Date(current);  // Assume current is in a parsable date format

        // setCurrentMonth(date);
        const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        // Set the min and max date for the date input

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');  // Add leading zero
          const day = String(date.getDate()).padStart(2, '0');         // Add leading zero
          return `${year}-${month}-${day}`;
      };
        
        setMinDate(formatDate(startOfMonth));
        setMaxDate(formatDate(endOfMonth));

       console.log(formatDate(startOfMonth), formatDate(endOfMonth));

      }
           else {
            navigate('/login');
            return;
          }

    
        } catch (e) {
          alert('Failed to fetch the input from storage');
        }
      };
    
      useEffect(() => {
        readData();
      }, []);
  
  
        const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${bearer}`
    };

      const fetchCustomers = async () => {
               
                try {
                  const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
                  console.log(response)
                  // const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
                  const results = response.data?.data;
                  console.log("results:", results)
                  const options = results.map((item) => ({
                    label: item.name,
                    value: item.id,
                    balance: item.balance
                  }));
                  setCus(options);
                } catch (error) {
                  const errorStatus = error.response?.data?.message;
                  console.log(errorStatus);
                  setCus([]);
                } finally {
                 
                }
              };
          useEffect(() => {
                    if (bearer) {
                      // fetchSupplierss();
                      // fetchLoans();
                      fetchCustomers();
                    }
                  }, [bearer]);
            
 const handlePaymentChange = (selectedOption) => {
             if (selectedOption) {
                 const selectedValue = selectedOption.value; // Access the value here
                 console.log('Selected value:', selectedValue); // For debugging
                 // Set the selected payment mode or perform any other action you need
                 // setSelectedPaymentMode(selectedValue); // Assuming you're updating the payment mode
           
                 setSelectedBanks(selectedValue);
           
             } else {
                 console.error('Selected option is undefined');
             }
           };
           
               const fetchDebit1 = async () => {
                 setLoading(true);
             
                 try {
                   const response = await axios.get(`${BASE_URL}/account/expenses`, { headers });
             
                   const debt1 = response.data?.data;
                   const oopt1 = debt1.map((item) => ({
                     label: `${item.gl_code} - ${item.gl_name}`,
                     value: item.id,
             
             
                   }));
                   setDebit1(oopt1);
             
             
             
                 } catch (error) {
                   const errorStatus = error.response.data.message;
                   // console.error(errorStatus);
                 } finally {
                   setLoading(false);
                 }
               };
               const fetchDebit3 = async () => {
                 setLoading(true);
             
                 try {
                   const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
             
                   const debt1 = response.data?.data;
                   const oopt1 = debt1.map((item) => ({
                     label: `${item.gl_code} - ${item.gl_name}`,
                     value: item.id,
             
             
                   }));
                   setDebit3(oopt1);
             
             
             
                 } catch (error) {
                   const errorStatus = error.response.data.message;
                   // console.error(errorStatus);
                 } finally {
                   setLoading(false);
                 }
               };
             
               const fetchDebit2 = async () => {
                 setLoading(true);
             
                 try {
                   const response = await axios.get(`${BASE_URL}/account/payables`, { headers });
             
                   const debt2 = response.data?.data;
                   const oopt2 = debt2.map((item) => ({
                     label: `${item.gl_code} - ${item.gl_name}`,
                     value: item.id,
             
             
                   }));
                   setDebit2(oopt2);
             
             
             
                 } catch (error) {
                   const errorStatus = error.response.data.message;
                   // console.error(errorStatus);
                 } finally {
                   setLoading(false);
                 }
               };
               const fetchDebit4 = async () => {
                 setLoading(true);
             
                 try {
                   const response = await axios.get(`${BASE_URL}/account/cash`, { headers });
             
                   const debt2 = response.data?.data;
                   const oopt2 = debt2.map((item) => ({
                     label: `${item.gl_code} - ${item.gl_name}`,
                     value: item.id,
             
             
                   }));
                   setDebit4(oopt2);
             
             
             
                 } catch (error) {
                   const errorStatus = error.response.data.message;
                   // console.error(errorStatus);
                 } finally {
                   setLoading(false);
                 }
               };
              const fetchLoanAccount = async () => {
                setLoanAccountOptions([])
                 setIsLoading(true);
                 try {
                   const response = await axios.get(`${BASE_URL}/account/fetch_select_loans_new?customer_id=${reference}`, { headers });
                   const results = response.data?.data;
                   const opt1 = results.map((item) => ({
                     value: item?.id,
                  label: `${item?.description}${item?.customer_balance != null ? ` - (bal: ${item.customer_balance.toLocaleString()})` : ''}`,
                     gl_code: item?.report?.gl_code,
                     gl_name: item?.report?.gl_name,
                     gl_id: item?.report?.id
                   }));
                
                   setLoanAccountOptions(opt1);
             
                 } catch (error) {
                   const errorStatus = error.response?.data?.message;
                   console.log(errorStatus);
                   setLoanAccountOptions([]);
                 } finally {
                   setIsLoading(false);
                 }
               };
             
               useEffect(() => {
                   fetchLoanAccount();
               },[reference])

               useEffect(() => {
                 if (bearer) {
                   fetchDebit1();
                   fetchDebit2();
                   fetchDebit3();
                   fetchDebit4();
                 }
               }, [bearer]);
  useEffect(() => {
    const fetchCustomers = async () => {
      if (!receiptType?.toLowerCase()?.includes("credit-customer")) return;

      try {
        setCustomerLoading(true);
        const token = localStorage.getItem("userToken");
        const res = await axios.get(`${BASE_URL}/customer/no-pagination`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });


        if (res.data.data && Array.isArray(res.data.data)) {
          setCustomerOptions(res.data.data);
        } else {
          setCustomerOptions([]);
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
        setCustomerOptions([]);
      } finally {
        setCustomerLoading(false);
      }
    };

    fetchCustomers();
  }, [receiptType]);

useEffect(() => {
  const fetchStaffLoans = async () => {
    if (!receiptType?.toLowerCase()?.includes("loan-repayment")) return;

    try {
      setLoanLoading(true);
      const token = localStorage.getItem("userToken");
      // const res = await axios.get(`${BASE_URL}/account/fetch-staff-loan`, {
      const res = await axios.get(`${BASE_URL}/customer/loan-customers-select`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      console.log("Loans fetched:", res?.data?.data);

      if (res.data.data && Array.isArray(res.data.data)) {
        setLoanOptions(res.data.data); // ✅ correct state
      } else {
        setLoanOptions([]);
      }
    } catch (err) {
      console.error("Error fetching staff loans:", err);
      setLoanOptions([]);
    } finally {
      setLoanLoading(false);
    }
  };
  fetchStaffLoans();
}, [receiptType]);

// useEffect(() => {
//   const fetchLoanAccount = async () => {
//     if (!receiptType?.toLowerCase()?.includes("loan-repayment")) return;

//     try {
//       setLoanLoading(true);
//       const token = localStorage.getItem("userToken");
     
//       const res = await axios.get(`${BASE_URL}/account/fetch_select_loans`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       });

//       console.log("Loans fetched:", res?.data?.data);

//       if (res.data.data && Array.isArray(res.data.data)) {
//         setLoanAccountOptions(res.data.data); 
//       } else {
//         setLoanAccountOptions([]);
//       }
//     } catch (err) {
//       console.error("Error fetching staff loans:", err);
//       setLoanAccountOptions([]);
//     } finally {
//       setLoanLoading(false);
//     }
//   };
//   fetchLoanAccount();
// }, [receiptType]);


  useEffect(() => {
    const fetchReceiptTypes = async () => {
      try {
        const token = localStorage.getItem("userToken");
        const res = await axios.get(`${BASE_URL}/get_type_of_receipts`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
console.log(res)
        if (res.data && Array.isArray(res.data.data)) {
          setReceiptTypes(res.data.data);
        } else {
          setReceiptTypes([]);
        }
      } catch (err) {
        console.error("Error fetching receipt types:", err);
        setReceiptTypes([]);
      }
    };

    fetchReceiptTypes();
  }, []);

  // === FETCH EXPENSE ACCOUNTS ===
  useEffect(() => {
    const fetchExpenseAccounts = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/get-expense-account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          const options = res.data.data.map((item) => ({
            value: item.id,
            label: item.gl_name,
          }));
          setExpenseOptions(options);
        }
      } catch (err) {
        console.error("Failed to fetch expense accounts", err);
      }
    };
    fetchExpenseAccounts();
  }, []);

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/fetch-all-currencies`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (res.data && Array.isArray(res.data.data)) {
          setCurrencyOptions(res.data.data);

          // ✅ Set NGN as default
          const ngnCurrency = res.data.data.find(c => c.code === "NGN");
          if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
        }
      } catch (err) {
        console.error("Error fetching currencies:", err);
      }
    };
    fetchCurrencies();
  }, []);

  // === FETCH PAYMENT MODES ===
  useEffect(() => {
    const fetchPaymentModes = async () => {
      try {
        const token = localStorage.getItem("userToken");
        const res = await axios.get(`${BASE_URL}/income/get-payment-method`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (res.data && Array.isArray(res.data.data)) {
          setPaymentModes(res.data.data);
        } else {
          setPaymentModes([]);
        }
      } catch (err) {
        console.error("Error fetching payment modes:", err);
        setPaymentModes([]);
      }
    };
    fetchPaymentModes();
  }, []);

  const [debitAccountsLoading, setDebitAccountsLoading] = useState(false);

  useEffect(() => {
    const fetchDebitAccounts = async () => {
      if (!selectedPaymentMode) return;
      const token = localStorage.getItem("userToken");
      let endpoint = "";

      const selectedModeName = paymentModes.find(m => m.id == selectedPaymentMode)?.name?.toLowerCase();

      if (selectedModeName?.includes("bank") || selectedModeName?.includes("transfer") || selectedModeName?.includes("teller")) {
        endpoint = `${BASE_URL}/account/bank-accounts`;
      } else if (selectedModeName?.includes("cheque") || selectedModeName?.includes("cash")) {
        endpoint = `${BASE_URL}/account/cash`;
      }

      if (!endpoint) return;

      setDebitAccountsLoading(true); // ✅ Start loader

      try {
        const res = await axios.get(endpoint, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (res.data && Array.isArray(res.data.data)) {
          const options = res.data.data.map((item) => ({
            value: item.id,
            label: item.gl_name || item.name,
          }));
          setExpenseOptions(options);
        } else {
          setExpenseOptions([]);
        }
      } catch (err) {
        console.error("Error fetching debit account options:", err);
        setExpenseOptions([]);
      } finally {
        setDebitAccountsLoading(false); // ✅ Stop loader
      }
    };

    fetchDebitAccounts();
  }, [selectedPaymentMode, paymentModes]);


  // === FETCH ACCOUNTS ===
  useEffect(() => {
   
    const fetchAccounts = async () => {
      const token = localStorage.getItem("userToken");
      // if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/account/incomes`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
     
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setAccounts(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setAccounts([]);
      } finally {
        setAccountsLoading(false);
      }
    };

    if (isOpen) {
      fetchAccounts();
    }
  }, [isOpen]);

  const [receivablesAcct, setReceivablesAcct] = useState([]);

  useEffect(() => {
   
    const fetchReceiveables = async () => {
      const token = localStorage.getItem("userToken");
      // if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/get-loans-receivables`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
     
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setReceivablesAcct(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setReceivablesAcct([]);
      } finally {
        setAccountsLoading(false);
      }
    };

    if (isOpen) {
      fetchReceiveables();
    }
  }, [isOpen]);


   const fetchCurrency = async () => {
       
        try {
            const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
            const results = response.data?.data;
            // console.log(results, "currencis")
            const options = results.map((item) => ({
                label: item.name || item.code,
                value: item.id,
                symbol: item.symbol
            }));
        
            setCurrencyOptions(options);
        } catch (error) {
            const errorStatus = error.response?.data?.message;
            console.log(errorStatus);
          
        } finally {
            
        }
    };

   const fetchMode = async () => {
       
        try {
            const response = await axios.get(`${BASE_URL}/income/get-payment-method`, { headers });
            const results = response.data?.data;
            setPaymentModes(results);
        } catch (error) {
            const errorStatus = error.response?.data?.message;
            console.log(errorStatus);
          setPaymentModes([]);
        } finally {
            
        }
    };

      // const fetchDebit1 = async () => {
      //       setLoading(true);
        
      //       try {
      //         const response = await axios.get(`${BASE_URL}/account/bank-accounts`,{headers});
            
      //         const debt1 = response.data?.data;
      //         const oopt1 = debt1.map((item) => ({
      //           label: `${item.gl_code} - ${item.gl_name}`,
      //           value: item.id,
             
                
      //         }));
      //         setDebit1(oopt1);
         
        
          
      //       } catch (error) {
      //         const errorStatus = error.response.data.message;
      //         console.error(errorStatus);
      //       } finally {
      //         setLoading(false);
      //       }
      //     };
      //   const fetchDebit2 = async () => {
      //       setLoading(true);
        
      //       try {
      //         const response = await axios.get(`${BASE_URL}/account/cash`,{headers});
            
      //         const debt2 = response.data?.data;
      //         const oopt2 = debt2.map((item) => ({
      //           label: `${item.gl_code} - ${item.gl_name}`,
      //           value: item.id,
             
                
      //         }));
      //         setDebit2(oopt2);
         
        
          
      //       } catch (error) {
      //         const errorStatus = error.response.data.message;
      //         console.error(errorStatus);
      //       } finally {
      //         setLoading(false);
      //       }
      //     };

  useEffect(() => {
    if (bearer) {
      fetchCurrency();
      fetchMode();
      //  fetchDebit1();
      //       fetchDebit2();
      //   fetchTotalExpenses();
    }
  }, [bearer]);

  const clearModalValues = () => {
    setRows([{ accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false }]);
    setPayer("");
    setReceiptType("");
    setReference("");
    setDescription("");
    setDebitAccount("");
    setTotalAmount("");
    setSelectedPaymentMode("");
    setTransactionDate("");
    setSelectedCurrency("");
    setLoanAccountSelected("");
    setTeller("");
    setAccountCode("");
    setAccountName("");
    setAccountNameId("");
  };

  useEffect(() => {
    if (!isOpen) {
      clearModalValues();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  // === TABLE HANDLERS ===
  const addLine = () => {
    setRows((prev) => [
      ...prev,
      { accountId: "", accountDisplay: "", amount: "", showDropdown: false },
    ]);
  };

  const duplicateRow = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const emptyRow = {
        accountId: "",
        accountDisplay: "",
        amount: "",
        showDropdown: false,
      };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setRows((prev) => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleChange = (index, field, value) => {
    setRows((prev) => {
      const newRows = [...prev];
      const row = { ...newRows[index] };

      if (field === "showDropdown") {
        row.showDropdown = value;
      } else if (field === "account") {
        row.accountId = value?.id ?? "";
        row.accountDisplay = `${value?.gl_name ?? value?.name ?? ""}`;
        row.accountCode = value?.gl_code ?? value?.code ?? "";
        row.showDropdown = false;
      } else if (field === "accountDisplay") {
        row.accountDisplay = value;
        row.accountId = "";
        row.accountCode = "";
        row.showDropdown = true;
      } else if (field === "amount") {
        row.amount = value;
      }

      newRows[index] = row;
      return newRows;
    });
  };


  const totalDebit = parseFloat(totalAmount || 0);
  const totalCredit = rows.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0
  );
  const isBalanced = totalDebit === totalCredit;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const authToken = localStorage.getItem("authToken");

    if (totalDebit !== totalCredit) {
      Swal.fire({
        icon: "error",
        title: "Unbalanced Entry",
        text: "Total Debit and Total Credit must balance before saving.",
        confirmButtonColor: "#3085d6",
        customClass: { popup: "swal-highest-zindex" },
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = "99999";
        },
      });
      return;
    }

    setIsSaving(true);

    try {
      // ✅ Include type_of_receipt and dynamically assign the correct reference field
      const typeId =
        receiptType?.id ||
        receiptTypes?.find(
          (t) => t.name === receiptType || t.type_name === receiptType
        )?.id ||
        receiptType;

      const payload = {
        description,
        currency: selectedCurrency?.id || selectedCurrency,
        payment_mode: selectedPaymentMode?.id || selectedPaymentMode,
        transaction_date: transactionDate,
        gl_code: debitAccount?.gl_code || debitAccount || "",
        total_amount: totalCredit,
        account_id: rows.map((row) => row.accountId),
        breakdown_amount: rows.map((row) => parseFloat(row.amount || 0)),
        type_of_receipt: typeId,
      };

      if (typeId == 2) {
        payload.received_from = reference;
      } else if (typeId == 3) {
        payload.repayment = reference;
      } else {
        payload.particulars = reference;
      }

      const response = await axios.post(`${BASE_URL}/post-receipt`, payload, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          imageUrl: verified,
          title: "Receipt Saved",
          text:
            response.data?.message ||
            "The cash receipt has been successfully saved!",
          confirmButtonText: "Print",
          confirmButtonColor: "#16A34A",
          customClass: { popup: "swal-highest-zindex" },
          didOpen: () => {
            const swalContainer = document.querySelector(".swal2-container");
            if (swalContainer) swalContainer.style.zIndex = "99999";
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const receiptData = {
              reference,
              transactionDate,
              description,
              selectedCurrency,
              selectedPaymentMode,
              debitAccount,
              totalAmount: totalCredit,
              rows,
            };

            navigate("/preview", {
              state: { invoice: receiptData },
            });
          } else {
            setRows([
              {
                accountId: "",
                accountDisplay: "",
                accountCode: "",
                amount: "",
                showDropdown: false,
              },
            ]);
            setPayer();
            setReceiptType();
            setReference("");
            setDescription("");
            setDebitAccount("");
            setTotalAmount("");
            setSelectedPaymentMode("");
            setTransactionDate("");
            setIsSaving(false);
            onClose();
          }
        });
      }
    } catch (error) {
      console.error("Save error:", error);
      Swal.fire({
        imageUrl: crop,
        title: "Save Failed",
        text:
          typeof error.response?.data?.message === "object"
            ? Object.values(error.response.data.message).flat().join(", ")
            : error.response?.data?.message ||
            "An error occurred while saving the receipt. Please try again.",
        confirmButtonColor: "#000000ff",
        customClass: { popup: "swal-highest-zindex" },
        didOpen: () => {
          const swalContainer = document.querySelector(".swal2-container");
          if (swalContainer) swalContainer.style.zIndex = "99999";
        },
      });
    } finally {
      setIsSaving(false);
    }
  };




 


const handleReceiptType = (e) => {
 setPayer("");
 setReference("");
 setLoanAccountSelected(null);
 setAccountCode("");
 setAccountName("");
 setAccountNameId("");
  setReceiptType(e.target.value);
}

const createIncome12 = async () => {
  setIncomeLoading(true);

  try {
    // Prepare debit_gl (array of account IDs) and breakdown_amount (array of numbers)
    const debit_gl = rows.map((row) => row.account?.id || row.accountId).filter(Boolean);
    const breakdown_amount = rows.map((row) => Number(row.amount) || 0).filter((a) => a > 0);

    const basePayload = {
      receipt_type: receiptType === "general-income" ? 1: receiptType === "credit-customer" ? 2 : 3,
      transaction_date: transactionDate,
      currency: selectedCurrency,
      loan_account_id: loanAccountSelected,
      payment_mode: selectedPaymentMode,
      description,
      credit_gl: debitAccount, // selected debit account ID from your form
      total_amount: totalAmount,
      debit_gl: [accountNameId] || debit_gl,
      breakdown_amount,
      reference_no: teller, // Teller or Reference field
    };

    // Conditionally include fields based on receipt type
    if (receiptType === "general-income") {
      basePayload.particulars = payer; // from your "Received From" input
    } else if (receiptType === "credit-customer") {
      basePayload.customer_id = reference; // selected customer ID
    } else if (receiptType === "loan-repayment") {
      basePayload.customer_id = reference; // selected loan ID
    }


    const response = await axios.post(`${BASE_URL}/post_receipt`, basePayload, { headers });

    Swal.fire({
      icon: "success",
      title: "Success",
      text: response.data.message,
    });
setReceiptType("");
setTransactionDate("");
setSelectedCurrency("");
setLoanAccountSelected("");
setDescription("");
setDebitAccount("");
setTotalAmount("");
setDebit1("");
setDebit2("");
setTeller("")

    onClose();
    fetchExpenses()
  } catch (error) {
    let errorMessage = "An error occurred. Please try again.";
    if (error.response?.data?.message) {
      if (typeof error.response.data.message === "string") {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join("; ");
      } else if (typeof error.response.data.message === "object") {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }

    console.error(error);
    Swal.fire({
      icon: "error",
      title: "Failed",
      text: errorMessage,
    });
  } finally {
    setIncomeLoading(false);
  }
};

const createIncome = async () => {
  setIncomeLoading(true);

  try {
    // Prepare debit_gl (array of account IDs) and breakdown_amount (array of numbers)
    const debit_gl_from_rows = rows
      .map((row) => row.account?.id || row.accountId)
      .filter(Boolean);

    const breakdown_amount = rows
      .map((row) => Number(row.amount) || 0)
      .filter((a) => a > 0);

    // ✅ Determine final debit_gl
    let finalDebitGL;

    // Check if accountNameId is empty or equals [""]
    if (
      !accountNameId ||
      accountNameId.length === 0 ||
      (accountNameId.length === 1 && accountNameId[0] === "")
    ) {
      finalDebitGL = debit_gl_from_rows;
    } else {
      finalDebitGL = [accountNameId].flat().filter(Boolean); // ensure it's a proper array
    }

    // ✅ Build payload
    const basePayload = {
      receipt_type:
        receiptType === "general-income"
          ? 1
          : receiptType === "credit-customer"
          ? 2
          : 3,
      transaction_date: transactionDate,
      currency: selectedCurrency,
      loan_account_id: loanAccountSelected,
      payment_mode: selectedPaymentMode,
      description,
      credit_gl: debitAccount, // selected debit account ID from your form
      total_amount: totalAmount,
      debit_gl: finalDebitGL, // ✅ now correctly set
      breakdown_amount,
      reference_no: teller, // Teller or Reference field
    };

    // ✅ Conditionally include fields based on receipt type
    if (receiptType === "general-income") {
      basePayload.particulars = payer; // from your "Received From" input
    } else if (receiptType === "credit-customer") {
      basePayload.customer_id = reference; // selected customer ID
    } else if (receiptType === "loan-repayment") {
      basePayload.customer_id = reference; // selected loan ID
    }

    // ✅ Send to API
    const response = await axios.post(`${BASE_URL}/post_receipt`, basePayload, { headers });

    Swal.fire({
      icon: "success",
      title: "Success",
      text: response.data.message,
    });

    // ✅ Reset form fields
    setReceiptType("");
    setTransactionDate("");
    setSelectedCurrency("");
    setLoanAccountSelected("");
    setDescription("");
    setDebitAccount("");
    setTotalAmount("");
    setDebit1("");
    setDebit2("");
    setTeller("");

    onClose();
    fetchExpenses();
  } catch (error) {
    let errorMessage = "An error occurred. Please try again.";
    if (error.response?.data?.message) {
      if (typeof error.response.data.message === "string") {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join("; ");
      } else if (typeof error.response.data.message === "object") {
        errorMessage = JSON.stringify(error.response.data.message);
      }
    }

    console.error(error);
    Swal.fire({
      icon: "error",
      title: "Failed",
      text: errorMessage,
    });
  } finally {
    setIncomeLoading(false);
  }
};
 const handleReferenceChange = (selectedOption) => {
  setLoanAccountOptions([])
  setSelectedLoanAccount("")
  const value = selectedOption ? selectedOption.value : "";
  setReference(value);
};



   

  return (
  <Modal show={isOpen} onHide={onClose} centered size="xl" backdrop="static"  contentClassName={classes.modalContentPadding}  >

      <h3 className={classes.title}>Cash Receipt</h3>

      <Row className={classes.formRow}>
        <Col xs={4} className={classes.formCol}>
          <label>Type of Receipt</label>
          <select
            value={receiptType}
            onChange={(e) => handleReceiptType(e)}
          >
            <option value="" disabled>Select Type</option>
            <option key="general-income" value="general-income">
              General Income
            </option>
            <option key="credit-customer" value="credit-customer">
              From Credit Customer
            </option>
            <option key="loan-repayment" value="loan-repayment">
              Loan Repayment
            </option>
          </select>
        </Col>
        <Col xs={4} className={classes.formCol}>
          <label>Received From</label>
          {receiptType === 'general-income' ? (
            <input
              type="text"
              placeholder="Enter payer name"
              style={{ width: "100%" }}
              value={payer}
              onChange={(e) => setPayer(e.target.value)}
            />
          ) : receiptType === 'credit-customer' ? (
            <Select
              value={
                reference
                  ? customerOptions
                      .map((cust) => ({
                        value: cust.id,
                        label: cust.name || cust.customer_name || cust.business_name,
                      }))
                      .find((opt) => opt.value === reference)
                  : null
              }
              onChange={(selectedOption) => setReference(selectedOption?.value || "")}
              options={customerOptions.map((cust) => ({
                value: cust.id,
               label: `${cust.name}${cust?.balance != null ? ` - (bal: ${cust.balance.toLocaleString()})` : ''}`,
              }))}
              isDisabled={customerLoading}
              isLoading={customerLoading}
              placeholder={customerLoading ? "Loading customers..." : "Select Customer"}
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "32px",
                  height: "32px",
                  fontSize: "12px",
                  borderColor: "#ccc",
                  boxShadow: "none",
                  "&:hover": { borderColor: "#999" },
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: "32px",
                  padding: "0 6px",
                }),
                input: (base) => ({
                  ...base,
                  margin: 0,
                  padding: 0,
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: "32px",
                }),
                placeholder: (base) => ({
                  ...base,
                  fontSize: "13px",
                  color: "#888",
                }),
                menu: (base) => ({
                  ...base,
                  fontSize: "12px",
                }),
              }}
            />
          ) : receiptType === 'loan-repayment' ? (
            <Select
              value={
                reference
                  ? loanOptions
                      .map((loan) => ({
                        value: loan.id,
                        label: `${loan?.name || "N/A"} - ${loan?.name || "Unknown"}`,
                      }))
                      .find((opt) => opt.value === reference)
                  : null
              }
              onChange={handleReferenceChange}
              options={loanOptions.map((loan) => ({
                value: loan.id,
                label: `${loan?.name || "N/A"}`,
              }))}
              isDisabled={loanLoading}
              isLoading={loanLoading}
              placeholder={loanLoading ? "Loading loans..." : "Select Loan"}
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "32px",
                  height: "32px",
                  fontSize: "12px",
                  borderColor: "#ccc",
                  boxShadow: "none",
                  "&:hover": { borderColor: "#999" },
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: "32px",
                  padding: "0 6px",
                }),
                input: (base) => ({
                  ...base,
                  margin: 0,
                  padding: 0,
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: "32px",
                }),
                placeholder: (base) => ({
                  ...base,
                  fontSize: "13px",
                  color: "#888",
                }),
                menu: (base) => ({
                  ...base,
                  fontSize: "12px",
                }),
              }}
            />
          ) : null}
        </Col>
        <Col xs={4} className={classes.formCol}>
          <label>Date</label>
          <input
            type="date"
            value={transactionDate}
            onChange={(e) => setTransactionDate(e.target.value)}
            required
            min={minDate}
            max={maxDate}
          />
        </Col>
        <Col xs={6} className={classes.formCol}>
          <label>Description</label>
          <input
            type="text"
            placeholder="Enter description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Col>
        <Col xs={3} className={classes.formCol}>
          <label>Currency</label>
          <Select
            value={
              selectedCurrency
                ? currencyOptions.find((option) => option.value === selectedCurrency)
                : null
            }
            onChange={(selectedOption) => setSelectedCurrency(selectedOption?.value || "")}
            options={currencyOptions}
            placeholder="Currency"
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "32px",
                height: "32px",
                fontSize: "12px",
                borderColor: "#ccc",
                boxShadow: "none",
                "&:hover": { borderColor: "#999" },
              }),
              valueContainer: (base) => ({
                ...base,
                height: "32px",
                padding: "0 6px",
              }),
              input: (base) => ({
                ...base,
                margin: 0,
                padding: 0,
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: "32px",
              }),
              placeholder: (base) => ({
                ...base,
                fontSize: "13px",
                color: "#888",
              }),
              menu: (base) => ({
                ...base,
                fontSize: "12px",
              }),
            }}
          />
        </Col>
        <Col xs={3} className={classes.formCol}>
          <label>Mode of Receipt</label>
          <select
            value={selectedPaymentMode}
            onChange={(e) => setSelectedPaymentMode(e.target.value)}
          >
            <option value="">Select Payment Mode</option>
            {paymentModes.map((m) => (
              <option key={m.id} value={m.id}>
                {m.name}
              </option>
            ))}
          </select>
        </Col>
        <Col xs={4} className={classes.formCol}>
          <label>Debit Account</label>
          <Select
            value={
              debitAccount
                ? expenseOptions.find((opt) => opt.value === debitAccount)
                : null
            }
            onChange={(selectedOption) => setDebitAccount(selectedOption?.value || "")}
            options={expenseOptions}
            isDisabled={debitAccountsLoading}
            isLoading={debitAccountsLoading}
            placeholder={
              debitAccountsLoading ? "Loading accounts..." : "Select Debit Account"
            }
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "32px",
                height: "32px",
                fontFontSize: "12px",
                borderColor: "#ccc",
                boxShadow: "none",
                "&:hover": { borderColor: "#999" },
              }),
              valueContainer: (base) => ({
                ...base,
                height: "32px",
                padding: "0 6px",
              }),
              input: (base) => ({
                ...base,
                margin: 0,
                padding: 0,
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: "32px",
              }),
              placeholder: (base) => ({
                ...base,
                fontSize: "13px",
                color: "#888",
              }),
              menu: (base) => ({
                ...base,
                fontSize: "12px",
              }),
            }}
          />
        </Col>
        <Col xs={4} className={classes.formCol}>
          <label>Total Amount</label>
          <input
            type="number"
            placeholder="Enter Amount"
            style={{ textAlign: "right", width: "100%" }}
            value={totalAmount}
            onChange={(e) => setTotalAmount(e.target.value)}
          />
        </Col>
        <Col xs={4} className={classes.formCol}>
          <label>Loan Account</label>
          <Select
            value={
              loanAccountSelected
                ? loanAccountOptions.find((option) => option.value === loanAccountSelected)
                : null
            }
             options={loanAccountOptions}
            onChange={(selectedOption) => {
              if (selectedOption) {
                setLoanAccountSelected(selectedOption?.value || "");
                setAccountCode(selectedOption?.gl_code || ""); // ✅ auto-fill expense_gl
                setAccountName(selectedOption?.gl_name || ""); // ✅ auto-fill expense_gl
                setAccountNameId(selectedOption?.gl_id || ""); // ✅ auto-fill expense_gl
              } else {
                // if cleared, reset values
                setLoanAccountSelected(null);
                setAccountCode("");
                setAccountName("");
                setAccountNameId("");
              }
            }}
              // onChange={(selectedOption) => setLoanAccountSelected(selectedOption?.value || "")}
            isDisabled={receiptType !== 'loan-repayment'}
            placeholder="Select loan account"
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "32px",
                height: "32px",
                fontSize: "12px",
                borderColor: "#ccc",
                boxShadow: "none",
                "&:hover": { borderColor: "#999" },
              }),
              valueContainer: (base) => ({
                ...base,
                height: "32px",
                padding: "0 6px",
              }),
              input: (base) => ({
                ...base,
                margin: 0,
                padding: 0,
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: "32px",
              }),
              placeholder: (base) => ({
                ...base,
                fontSize: "13px",
                color: "#888",
              }),
              menu: (base) => ({
                ...base,
                fontSize: "12px",
              }),
            }}
          />
          {/* <Select
            value=""
            onChange=""
            placeholder="Select loan account"
            // isDisabled={true}
            isLoading={loading}
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "32px",
                height: "32px",
                fontSize: "12px",
                borderColor: "#ccc",
                boxShadow: "none",
                "&:hover": { borderColor: "#999" },
              }),
              valueContainer: (base) => ({
                ...base,
                height: "32px",
                padding: "0 6px",
              }),
              input: (base) => ({
                ...base,
                margin: 0,
                padding: 0,
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: "32px",
              }),
              placeholder: (base) => ({
                ...base,
                fontSize: "13px",
                color: "#888",
              }),
              menu: (base) => ({
                ...base,
                fontSize: "12px",
              }),
            }}
          /> */}
        </Col>
        <Col xs={4} className={classes.formCol}>
          <label>Reference/Income/Loan No.</label>
          <input
            type="text"
            placeholder="Enter Teller"
            style={{ width: "100%" }}
            value={teller}
            onChange={(e) => setTeller(e.target.value)}
          />
        </Col>
      </Row>

      <h3 className={classes.titles}>Account Breakdown</h3>
      <table className={classes.tabless}>
        <thead>
          <tr>
            <th>#</th>
            <th>Account Name</th>
            <th>Account Code</th>
            <th>Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td className={classes.accountCell}>
                {receiptType === 'loan-repayment' ?(
                <input
                  type="text"
                  value={accountName}
                  readOnly
                  className={classes.readOnlyInput}
                   style={{
                    height: "32px",  
                    padding: "4px 10px",
                    fontSize: "13px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    width: "90%",
                    backgroundColor: "#f9f9f9",
                    boxSizing: "border-box",
                  }}
                />
                ): (
                  <Select
                     // Show selected value (based on accountId)
                     value={
                       row.accountId
                         ? {
                             value: row.accountId,
                             label: `${row.accountCode ?? ""} - ${row.accountDisplay ?? ""}`,
                           }
                         : null
                     }
                     // When user selects an account
                     onChange={(selectedOption) => {
  // Pick the same source used for options
  const source =
    receiptType === "credit-customer" ? receivablesAcct : accounts;

  // Be robust to id types (string vs number)
  const selectedAcc = selectedOption
    ? source.find((acc) => String(acc.id) === String(selectedOption.value))
    : null;

  handleChange(index, "account", selectedAcc);
}}

                     // When user types in the search field
                     onInputChange={(inputValue, { action }) => {
                       if (action === "input-change") {
                         handleChange(index, "accountDisplay", inputValue);
                       }
                     }}
                     // Dropdown options
                     options={
  receiptType === "credit-customer"
    ? receivablesAcct
        .filter((acc) => {
          const search = row.accountDisplay?.toLowerCase() || "";
          const text = `${acc.gl_code ?? acc.code ?? ""} ${
            acc.gl_name ?? acc.name ?? ""
          }`.toLowerCase();
          return text.includes(search);
        })
        .map((acc) => ({
          value: acc.id,
          label: `${acc.gl_code ?? acc.code ?? ""} - ${
            acc.gl_name ?? acc.name ?? ""
          }`,
        }))
    : accounts
        .filter((acc) => {
          const search = row.accountDisplay?.toLowerCase() || "";
          const text = `${acc.gl_code ?? acc.code ?? ""} ${
            acc.gl_name ?? acc.name ?? ""
          }`.toLowerCase();
          return text.includes(search);
        })
        .map((acc) => ({
          value: acc.id,
          label: `${acc.gl_code ?? acc.code ?? ""} - ${
            acc.gl_name ?? acc.name ?? ""
          }`,
        }))
}

                     isLoading={accountsLoading}
                     isClearable
                     placeholder="Search or type account..."
                     styles={{
                       control: (base) => ({
                         ...base,
                         minHeight: "32px",
                         height: "32px",
                         fontSize: "13px",
                         borderColor: "#ccc",
                         boxShadow: "none",
                         "&:hover": { borderColor: "#999" },
                         textAlign: "left", // 👈 ensure input text aligns left
                       }),
                       singleValue: (base) => ({
                         ...base,
                         textAlign: "left",
                       }),
                       placeholder: (base) => ({
                         ...base,
                         fontSize: "13px",
                         color: "#888",
                         textAlign: "left", 
                       }),
                       menu: (base) => ({
                         ...base,
                         fontSize: "13px",
                         zIndex: 10,
                         textAlign: "left",
                       }),
                     }}
                   />
                )}
              </td>
              <td>
              {receiptType === 'loan-repayment' ?(
                <input
                  type="text"
                  value={accountCode}
                  readOnly
                  className={classes.readOnlyInput}
                   style={{
                    height: "32px",  
                    padding: "4px 10px",
                    fontSize: "13px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    width: "90%",
                    backgroundColor: "#f9f9f9",
                    boxSizing: "border-box",
                  }}
                />
                ): (
                <input
                  type="text"
                  value={row.accountCode}
                  readOnly
                  className={classes.readOnlyInput}
                   style={{
                    height: "32px",  
                    padding: "4px 10px",
                    fontSize: "13px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    width: "90%",
                    backgroundColor: "#f9f9f9",
                    boxSizing: "border-box",
                  }}
                />
                )}
              </td>
              <td>
                <input
                  type="number"
                  className={classes.creditInput}
                  value={row.amount}
                  onChange={(e) =>
                    handleChange(index, "amount", e.target.value)
                  }
                   style={{
      height: "32px",       
      padding: "4px 10px", 
      fontSize: "13px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      width: "90%",
      backgroundColor: "#f9f9f9",
      boxSizing: "border-box",
    }}
                />
              </td>
              <td style={{ display: "flex" }}>
                <button
                  onClick={() => removeRow(index)}
                  className={classes.removeBtn}
                  disabled={
                    (receiptType?.toLowerCase()?.includes("credit-customer")) ||
                    receiptType?.toLowerCase()?.includes("loan-repayment")
                  }
                  style={{
                    opacity:
                      receiptType?.toLowerCase()?.includes("credit-customer") ||
                        receiptType?.toLowerCase()?.includes("loan-repayment")
                        ? 0.6
                        : 1,
                    cursor:
                      receiptType?.toLowerCase()?.includes("credit-customer") ||
                        receiptType?.toLowerCase()?.includes("loan-repayment")
                        ? "not-allowed"
                        : "pointer",
                  }}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className={classes.actionRow}>
        <button
          className={classes.addLineBtn}
          onClick={addLine}
          disabled={
            (receiptType?.toLowerCase()?.includes("credit-customer")) ||
            receiptType?.toLowerCase()?.includes("loan-repayment")
          }
          style={{
            opacity:
              receiptType?.toLowerCase()?.includes("credit-customer") ||
                receiptType?.toLowerCase()?.includes("loan-repayment")
                ? 0.6
                : 1,
            cursor:
              receiptType?.toLowerCase()?.includes("credit-customer") ||
                receiptType?.toLowerCase()?.includes("loan-repayment")
                ? "not-allowed"
                : "pointer",
          }}
        >
          + Add Line
        </button>
      </div>

      <div className={classes.totalRow}>
        <div className={classes.totalBox}>
          <span>Total Debit</span>
          <strong>{totalDebit.toFixed(2)}</strong>
        </div>
        <div className={classes.totalBox}>
          <span>Total Credit</span>
          <strong>{totalCredit.toFixed(2)}</strong>
        </div>
      </div>

      <div className={classes.footerButtons}>
        <button
          className={classes.resetBtn}
          onClick={() =>
            setRows([
              {
                accountId: "",
                accountDisplay: "",
                amount: "",
                showDropdown: false,
              },
            ])
          }
        >
          Reset
        </button>
        <button
          className={classes.submitBtn}
          onClick={createIncome}
          // disabled={incomeLoading || !isBalanced}
          disabled={incomeLoading}
          // style={{
          //   backgroundColor: incomeLoading || isBalanced ? "#ccc" : "#16A34A",
          //   cursor: incomeLoading || isBalanced ? "not-allowed" : "pointer",
          // }}
        >
          {incomeLoading ? (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <Spinner animation="border" size="sm" /> Saving...
            </span>
          ) : (
            "Save Receipt"
          )}
        </button>
      </div>

      <button className={classes.closeBtn} onClick={onClose}>
        ×
      </button>
    </Modal>
  );
}

export default CashReciept;